import React from 'react';
import { HStack, Dialog, Portal } from '@chakra-ui/react';
import PoliceEncounterForm from '@/components/form/police-encounter/PoliceEncounterForm';

const PoliceEncounterModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
   return (
      <HStack>
         <Dialog.Root placement="center" motionPreset="slide-in-bottom" open={isOpen}>
            <Portal>
               <Dialog.Backdrop />
               <Dialog.Positioner>
                  <Dialog.Content bg="#202020" rounded="15px" py="4" px="5" maxWidth="500px">
                     <PoliceEncounterForm onClose={onClose} />
                  </Dialog.Content>
               </Dialog.Positioner>
            </Portal>
         </Dialog.Root>
      </HStack>
   );
};

export default PoliceEncounterModal;
